/**
 * Creates a throttled version of a function that limits its invocation to at most once
 * every specified interval.
 *
 * @param {Function} fn - The function to throttle.
 * @param {number} wait - The interval in milliseconds during which the function should only be invoked once.
 * @param {Object} [options={}] - Configuration options for throttling behavior.
 * @param {boolean} [options.leading=true] - If true, the function will be triggered at the start of the interval.
 * @param {boolean} [options.trailing=true] - If true, the function will be triggered at the end of the interval.
 * @returns {Function} - Returns the throttled function.
 */
const throttle = (fn, wait, options = {}) => {
    const { leading = true, trailing = true } = options;
    let last = 0, timer;
    return function (...args) {
        const now = performance.now();
        if (!last && !leading)
            last = now;
        const remaining = wait - (now - last);
        if (remaining <= 0 || remaining > wait) {
            if (timer)
                clearTimeout(timer);
            last = now;
            fn.apply(this, args);
        }
        else if (trailing && !timer) {
            timer = setTimeout(() => {
                last = leading ? performance.now() : 0;
                timer = null;
                fn.apply(this, args);
            }, remaining);
        }
    };
};
export { throttle };
